(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('.announcement-bar__message');
    if (!el) return;

    var text = (el.textContent || '').trim();
    if (!text) return;

    // Create wrapper and track
    var wrapper = document.createElement('div');
    wrapper.className = 'announcement-marquee';
    var track = document.createElement('div');
    track.className = 'am-track';

    // Duplicate the text so it loops endlessly
    var span1 = document.createElement('span');
    span1.textContent = text + ' | ';
    var span2 = span1.cloneNode(true);

    track.appendChild(span1);
    track.appendChild(span2);
    wrapper.appendChild(track);

    // Replace old content
    el.innerHTML = '';
    el.appendChild(wrapper);

    // Auto adjust speed based on content width
    requestAnimationFrame(function () {
      var width = track.scrollWidth || 1000;
      var duration = Math.max(8, Math.round(width / 80));
      wrapper.style.setProperty('--am-duration', duration + 's');
    });
  });
})();
